/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ProcessState } from "./ProcessState";
import {
  ProcessStateFromJSON,
  ProcessStateFromJSONTyped,
  ProcessStateToJSON,
} from "./ProcessState";

export interface DigestionCreateRequest {
  locked?: boolean;
  workflowId?: string | null;
  workflowContext?: object | null;
  state?: ProcessState;
  logId: string;
  name?: string | null;
  note?: string | null;
  context?: object | null;
}

export function DigestionCreateRequestFromJSON(
  json: any,
): DigestionCreateRequest {
  return DigestionCreateRequestFromJSONTyped(json);
}

export function DigestionCreateRequestFromJSONTyped(
  json: any,
): DigestionCreateRequest {
  if (json == null) {
    return json;
  }

  return {
    locked: json["locked"],
    workflowId: json["workflow_id"],
    workflowContext: json["workflow_context"],
    state:
      json["state"] === undefined
        ? undefined
        : ProcessStateFromJSON(json["state"]),
    logId: json["log_id"],
    name: json["name"],
    note: json["note"],
    context: json["context"],
  };
}

export function DigestionCreateRequestToJSON(
  value: DigestionCreateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    locked: value.locked,
    workflow_id: value.workflowId,
    workflow_context: value.workflowContext,
    state: ProcessStateToJSON(value.state),
    log_id: value.logId,
    name: value.name,
    note: value.note,
    context: value.context,
  };
}
